define([
    "jquery",
    "underscore",
    "marionette",
    "google_analytics",
    "facebook_pixel",
    "behaviors/form_errors_behavior",
    "forms/register/land_prime_form",
    "behaviors/recaptcha_v3_behavior",
    "moment",
    "bootstrap.datepicker",
    "backbone.syphon",
    "holdon",
], function ($, _, Marionette, GoogleAnalytics, FacebookPixel, FormErrorsBehavior, LandPrimeForm, ReCaptchaV3Behavior, moment) {

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior,
            },
            recaptcha: {
                behaviorClass: ReCaptchaV3Behavior,
                action: '/register'
            }
        },

        ui: {
            landPrimeForm: '#land-prime-form',
            submitLandPrimeForm: '#submit-land-prime-form',

            sendEmailValidation: '#send_email_validation',
            resendVerificationEmail: '#resend_email_verification',

            checkEmailValidation: '#check_email_validation',

            emailValidationSuccessIcon: '#email_validation_success',
            emailValidationDesc: "#email_validation_desc",

            emailValidationCode: '#email_validation',
            validationType: '.validation_type',
            validationId: '.validation_id',
            validationPassed: '.validation_passed',

            birthDatePicker: '#birth',

            email: '#email',

            captchaCheckErrorMsg: '.captcha_check_error_msg',

            showPasswordBtn: "#show_password_btn",
            showConfirmPasswordBtn: "#show_confirm_password_btn",
            passwordInput: "#password",
            confirmPasswordInput: "#confirm_password",

            eachInput: "input.form-control",
            eachSelect: "select.form-control",
        },

        events: {
            'click @ui.submitBtn': 'submit',

            'click @ui.sendEmailValidation': 'sendEmailValidation',
            'click @ui.checkEmailValidation': 'checkEmailValidation',
            'click @ui.resendVerificationEmail': 'resendEmailValidation',

            'click @ui.submitLandPrimeForm': 'submit',

            "click @ui.showPasswordBtn": "showPasswordBtn",
            "click @ui.showConfirmPasswordBtn": "showConfirmPasswordBtn",
            "keyup @ui.passwordInput": "passwordValidation",
            "keyup @ui.confirmPasswordInput": "isSamePasswordValidation",

            "focus @ui.eachInput": "makeInputFocused",
            "focusout @ui.eachInput": "makeInputOutfocused",

            "focus @ui.eachSelect": "makeInputFocused",
            "focusout @ui.eachSelect": "makeInputOutfocused",

            "keyup @ui.email": "makeCodeButtonActive",
            "keyup @ui.emailValidationCode": "makeVerifyButtonActive",
        },

        initialize: function () {
            this.bindUIElements();
            this.doNotProvokeSubmitByEnterKey();

            // recaptcha
            this.triggerMethod('init:recaptcha');

            this.ui.birthDatePicker.datetimepicker({
                viewMode: 'years',
                format: 'YYYY-MM-DD',
                // We need to be 20years old to register to let's have the max date be 20years from now
                maxDate: moment().subtract(18, 'y')
            }).val('');

            // Only serve email validation
            if (window.create_land_prime_fail) {
                this.ui.validationType.val('email');
                this.ui.validationPassed.val('true');

                this.ui.emailValidationSuccessIcon.show();

                this.ui.resendVerificationEmail.show();
                this.ui.sendEmailValidation.hide();
                this.ui.checkEmailValidation.hide();
            }

            let gaUrl = GoogleAnalytics.googleAnalyticsUrls.land_prime_open;
            if (window.success) {
                gaUrl = GoogleAnalytics.googleAnalyticsUrls.land_prime_completion;

                FacebookPixel.sendCustomEvent(FacebookPixel.facebookEventNames.land_prime_success);
            }

            GoogleAnalytics.sendGaPageviewEvent(gaUrl);
        },

        makeInputFocused: function (e) {
            const focusedInput = $(e.target)
            const labelName = focusedInput.attr("name")
            const focusedLabel = $(`label[for=${labelName}]`);

            focusedInput.addClass('input-focused')
            focusedLabel.addClass('label-focused')
        },

        makeInputOutfocused: function (e) {
            const focusedInput = $(e.target)
            const labelName = focusedInput.attr("name")
            const focusedLabel = $(`label[for=${labelName}]`);

            focusedInput.removeClass('input-focused')
            focusedLabel.removeClass('label-focused')
        },

        makeCodeButtonActive: function (e) {
            const input = $(e.target)
            if (input.val().length > 0)
                this.ui.sendEmailValidation.addClass('button-active')
            else
                this.ui.sendEmailValidation.removeClass('button-active')
        },

        makeVerifyButtonActive: function (e) {
            const input = $(e.target)
            if (input.val().length == 4)
                this.ui.checkEmailValidation.addClass('button-active')
            else
                this.ui.checkEmailValidation.removeClass('button-active')
        },

        showPasswordBtn: function () {
            let inputElem = document.getElementById("password");
            if (inputElem.type === "text") {
                document.getElementById("show_password_btn_img").src =
                    "/assets/common/common/img/eye_icon_gray.svg";
                inputElem.type = "password";
            } else {
                document.getElementById("show_password_btn_img").src =
                    "/assets/common/common/img/hide_eye_gray.svg";
                inputElem.type = "text";
            }
        },

        showConfirmPasswordBtn: function () {
            let inputElem = document.getElementById("confirm_password");
            if (inputElem.type === "text") {
                inputElem.type = "password";
                document.getElementById("show_confirm_password_btn_img").src =
                    "/assets/common/common/img/eye_icon_gray.svg";
            } else {
                inputElem.type = "text";
                document.getElementById("show_confirm_password_btn_img").src =
                    "/assets/common/common/img/hide_eye_gray.svg";
            }
        },

        passwordValidation: function (e) {
            let password = e.target.value;
            let errorFound = false;

            // 글자수 8자 이상, 15자 이하
            let lengthRule = /^.{8,15}$/;
            if (lengthRule.test(password)) {
                document.getElementsByClassName("length")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("length")[0].style.display = "flex";
            }

            // 숫자 하나 이상 포함
            let digitRule = /\d/;
            if (digitRule.test(password)) {
                document.getElementsByClassName("number")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("number")[0].style.display = "flex";
            }

            // 특수문자 하나 이상 포함
            let specialCharRule = /[!@#$%^*+=-]+/;
            if (specialCharRule.test(password)) {
                document.getElementsByClassName("special-character")[0].style.display =
                    "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("special-character")[0].style.display =
                    "flex";
            }

            // 염문 대문자/소문자 포함
            let uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
            if (uppercaseRule.test(password)) {
                document.getElementsByClassName("uppercase")[0].style.display = "none";
            } else {
                errorFound = true;
                document.getElementsByClassName("uppercase")[0].style.display = "flex";
            }

            if (errorFound) {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "flex";
            } else {
                document.getElementsByClassName("first-validation-box")[0].style.display =
                    "none";
            }
        },

        isSamePasswordValidation: function (e) {
            let passwordForConfirm = e.target.value;
            if (
                document.getElementById("password").value === passwordForConfirm
            ) {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "none";
            } else {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "flex";
            }
        },

        doNotProvokeSubmitByEnterKey: function () {
            window.onkeydown = function (event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    return false;
                }
            }
        },

        // EMAIL VALIDATION : Resend verification code SMS
        resendEmailValidation: function (e) {
            if (e) e.preventDefault();
            this.ui.checkEmailValidation.show();
            this.sendEmailValidation(e);
        },

        // EMAIL VALIDATION : SEND-CODE TO THE INPUT EMAIL ADDRESS
        sendEmailValidation: function (e) {
            if (e) e.preventDefault();
            var that = this;

            if (this.ui.email.val().length < 1)
                return;

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            $.ajax('/rest_register/send_email_validation_code', {
                method: "POST",
                data: {
                    'email_address': this.ui.email.val()
                },
                success: function (data) {
                    that.triggerMethod('hide:errors');
                    that.ui.validationId.val(data.secureVerificationCd);

                    that.ui.resendVerificationEmail.show();
                    that.ui.sendEmailValidation.hide();

                    that.ui.emailValidationDesc.css("display", "block");
                    that.ui.checkEmailValidation.show();

                    HoldOn.close();

                },
                error: function (xhr, textStatus, errorThrown) {
                    var error = xhr.responseJSON;
                    that.triggerMethod('show:errors', {'email': error.error_message});
                    HoldOn.close();
                }
            })
        },

        // EMAIL VALIDATION AFTER CLICKING CODE VERIFICATION
        checkEmailValidation: function (e) {
            if (e) e.preventDefault();

            if (this.ui.emailValidationCode.val().length != 4)
                return;

            var that = this;
            that.triggerMethod("hide:errors");
            that.ui.emailValidationDesc.css("display", "none");

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            $.ajax('/rest_register/verify_email_validation', {
                method: "POST",
                data: {
                    'email_address': this.ui.email.val(),
                    'request_id': this.ui.validationId.val(),
                    'code': this.ui.emailValidationCode.val()
                },
                success: function (data) {
                    that.triggerMethod('hide:errors');
                    that.ui.validationType.val('email');
                    that.ui.validationPassed.val('true');

                    that.ui.emailValidationSuccessIcon.show();

                    that.ui.resendVerificationEmail.hide();
                    that.ui.checkEmailValidation.hide();

                    that.ui.email.css("color", "#AAB7F2");
                    that.ui.email.addClass("inactive");
                    that.ui.email.attr("readonly", true);

                    that.ui.emailValidationCode.css("color", "#AAB7F2");
                    that.ui.emailValidationCode.addClass("inactive");
                    that.ui.emailValidationCode.attr("readonly", true);

                    HoldOn.close();
                },
                error: function (xhr, textStatus, errorThrown) {
                    var error = xhr.responseJSON;
                    if (error.error_message) {
                        that.triggerMethod('show:errors', {'email_validation': error.error_message});
                    }
                    HoldOn.close();
                }
            })
        },

        submit: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');
            HoldOn.open({
                theme: "sk-fading-circle"
            });

            var formData = Backbone.Syphon.serialize(this);
            this.landPrimeForm = new LandPrimeForm();
            this.landPrimeForm.set(formData);

            var errors = this.landPrimeForm.validate();

            var that = this;

            if (_.size(errors) < 1) {
                this.triggerMethod('get:token', function (err, token) {
                    that.triggerMethod('set:token', token, that.ui.landPrimeForm);
                    formData = Backbone.Syphon.serialize(that);
                    that.landPrimeForm.set(formData);

                    that.landPrimeForm.validateWithServer({
                        type: 'POST',
                        success: function (model, res) {
                            that.ui.landPrimeForm.submit();
                        },
                        error: function (model, error) {
                            that.triggerMethod('show:errors', error.responseJSON);
                            HoldOn.close();
                        }
                    });
                });
            } else {
                HoldOn.close();
                this.triggerMethod('show:errors', errors);
            }
        },
    });
});
